module.exports = __webpack_public_path__ + "static/media/sidedrawer_background.6852b335.png";